export function getCurrentPosition({ timeout = 7000, enableHighAccuracy = true } = {}) {
  return new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      return reject(new Error('Geolocation not supported'))
    }

    let didTimeOut = false
    const timer = setTimeout(() => {
      didTimeOut = true
      reject(new Error('Geolocation timeout'))
    }, timeout)

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        if (didTimeOut) return
        clearTimeout(timer)
        resolve({
          lat: pos.coords.latitude,
          lon: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
          timestamp: pos.timestamp,
        })
      },
      (err) => {
        if (didTimeOut) return
        clearTimeout(timer)
        reject(err)
      },
      { enableHighAccuracy, maximumAge: 0, timeout },
    )
  })
}
